
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RepeatableEventsInterface } from '@/services/Calendar/RepeatableEvents/Interfaces';
import RepeatableEventsRepository from '@/services/Calendar/RepeatableEvents';

@Component({
  inject: [
    'repeatableEventsRepository',
  ],
})
export default class DeleteRepeatableEventDialog extends Vue {
  private readonly repeatableEventsRepository!: RepeatableEventsRepository;

  @Prop() private readonly repeatableEvent!: RepeatableEventsInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete '${this.repeatableEvent.name}'?`;
  }

  private async deleteRecurringEvent(): Promise<void> {
    try {
      await this.repeatableEventsRepository.deleteRepeatableEvent(this.repeatableEvent.id);
      this.$successDialog.show(`Repeatable event '${this.repeatableEvent.name}' has been deleted.`);
      this.$emit('deleted-repeatable-event', this.repeatableEvent.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
